import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import {
  updateNotificationSeenResponse,
  updateNotificationSeenRepository,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum updateNotificationSeenState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: updateNotificationSeenState;
  message: string;
}

const initialState: InitialState = {
  status: updateNotificationSeenState.initial,
  message: "",
};

export const updateNotificationSeen = createAsyncThunk(
  "updateNotificationSeen",
  async (param: { notificationId: string }, { rejectWithValue }) => {
    try {
      const response: updateNotificationSeenResponse =
        await updateNotificationSeenRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const updateNotificationSeenSlice = createSlice({
  name: "updateNotificationSeen",
  initialState,
  reducers: {
    resetupdateNotificationSeen: (state) => {
      state.status = updateNotificationSeenState.inProgress;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateNotificationSeen.pending, (state) => {
        state.status = updateNotificationSeenState.inProgress;
      })
      .addCase(updateNotificationSeen.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = updateNotificationSeenState.success;
          state.message = message;
        }
      })
      .addCase(updateNotificationSeen.rejected, (state, action) => {
        state.status = updateNotificationSeenState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectUpdateNotificationSeen = (state: RootState) =>
  state.updateNotificationSeen;

export const { resetupdateNotificationSeen } =
  updateNotificationSeenSlice.actions;
export default updateNotificationSeenSlice.reducer;
